import API from "./index"
import { getUsuario } from "../auth"

class ClasseService {
    constructor() {
        this.path = `api/classe`
    }

    async findAll({ page = 0, size = 10, descricao = "", situacao = null, apenasConsumo = null }) {
        const params = {
            page: page - 1 < 0 ? 0 : page - 1,
            size: size,
        }

        if (apenasConsumo != null)
            params.apenasConsumo = apenasConsumo;

        if (descricao !== "") {
            params.descricao = descricao.toString()
        }

        if (situacao !== null) {
            params.situacao = situacao
        }
        return await API.get(this.path, { params })
    }

    async findBySubgrupoId({
        page = 0,
        size = 10,
        descricao = "",
        situacao = null,
        subgrupoNumero = null,
    }) {
        const params = {
            page: page - 1 < 0 ? 0 : page - 1,
            size: size,
        }

        if (descricao !== "") {
            params.descricao = descricao.toString()
        }

        if (situacao !== null) {
            params.situacao = situacao
        }
        return await API.get(`${this.path}/subgrupo/${subgrupoNumero}`, { params })
    }

    findById(id) {
        return API.get(`${this.path}/${id}`)
    }

    async save(record) {
        if (record.id) {
            return await API.put(`${this.path}/${record.id}`, record).then(
                ({ ...args }) => ({ created: false, ...args })
            )
        }

        let usuario = getUsuario()
        return await API.post(this.path, { ...record, usuario }).then(
            ({ ...args }) => ({
                created: true,
                ...args,
            })
        )
    }

    async alteraSituacao({ id, situacao }) {
        return await API.put(`${this.path}/${id}/situacao`, { situacao }).then(
            ({ ...args }) => ({ created: false, ...args })
        )
    }

    buscaQuantidadeProdutos(record) {
        return API.get(`${this.path}/${record.id}/totalizador`)
    }

    mover(classeOrigem, classeDestino) {
        return API.put(
            `${this.path}/${classeOrigem.id}/mover/${classeDestino.id}`
        ).then(({ ...args }) => ({ created: false, ...args }))
    }

    remove(id) {
        if (!id) {
            throw new Error("ID cannot be null")
        }
        return API.delete(`${this.path}/${id}`)
    }
}

export default ClasseService
